
    <HistoryUploadSearch headerTextWP="Water Process History Upload" detailsType="Water Process" AddURL="/WaterProcess/WPHistoryUploadDetail">